import { lazy } from 'react';

// Types
import { KlarnaButtonProps as LazyComponentProps } from './KlarnaButton.types';

// Components
import withSuspense, { lazyRetry } from '../../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "klarnaButton" */ './KlarnaButton')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'KlarnaButton');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as KlarnaButton };
